import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '@api/api.service';
import { TwoFactorMethod } from '@api/users/me/twoFactor/two-factor.service';
import { ModalService } from '@shared/modal/modal.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'rav-verify2fa',
  templateUrl: './verify2fa.component.html',
  styleUrls: ['./verify2fa.component.scss']
})
export class Verify2faComponent implements OnInit, OnDestroy {
  @Input() redirectOnSuccess = true;
  @Output() close2faVerify = new EventEmitter<any>();
  subscriptionList: Subscription = new Subscription();
  modalData = null;
  code: number = null;
  errorMessage: string = null;
  expirationTime = 300;
  timer: any;

  constructor(
    public modal: ModalService,
    private api: ApiService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.subscriptionList.add(
      this.modal.open.subscribe((data) => {
        if (data && data['modalId'] === 'verify2fa-code') {
          this.modalData = data['modalData'];
          this.setTimer(300);
        }
      })
    );

    this.subscriptionList.add(
      this.modal.close.subscribe((data) => {
        if (data && data['modalId'] === 'verify2fa-code') {
          if (this.redirectOnSuccess) {
            this.router.navigated = false;
            this.router.navigate([this.router.url]);
          }
          this.close2faVerify.emit(data);

          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptionList.unsubscribe();
  }

  /**
   * Makes a request to api to resend the verification code.
   */
  resendCode(): void {
    const method = this.modalData['method'] === 'sms' ? TwoFactorMethod.SMS : TwoFactorMethod.VOICE;
    const data =
      this.modalData['method'] === 'sms'
        ? this.modalData.smsPhoneNumber.toString()
        : this.modalData.voicePhoneNumber.toString();
    this.api.users.me.twoFactor
      .post(method, data)
      .toPromise()
      .then(() => {
        this.setTimer(300);
      });
  }

  /**
   * Closes the 2FA modal.
   */
  closeModal(): void {
    this.modal.close.next({ modalId: 'verify2fa-code' });
  }

  /**
   * Makes a request to api to verify the code if successful closes the modal else displays the error.
   */
  verifyCode(): void {
    this.api.users.me.twoFactor.patch(this.code.toString()).subscribe(
      async (response) => {
        if (response['status'] === 200) {
          this.displaySuccessMessage('Two factor authentication setup successful');
          this.modal.close.next({ modalId: 'verify2fa-code' });
        }
      },
      (error) => {
        this.errorMessage = error.error.message;
      }
    );
  }

  /**
   * display the error message
   *
   * @param message the error message
   */
  displaySuccessMessage(message): void {
    this.snackBar.open(message, '', {
      duration: 5000,
      panelClass: ['success-bg', 'bold', 'light-color']
    });
  }

  /**
   * Set interval to count down the expiration time.
   *
   * @param seconds second to count down
   */
  private setTimer(seconds: number): void {
    this.expirationTime = seconds;
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.timer = setInterval(() => {
      this.expirationTime--;
      if (this.expirationTime === 0) {
        clearInterval(this.timer);
      }
    }, 1000);
  }
}
